import { useState } from "react";
import { ScrollView, StyleSheet } from "react-native";
import type { CoachAthleteCard } from "@heraion/shared";
import { CoachDashboard, resolveTheme, useCoachDashboard } from "@heraion/ui";

import { apiFetch } from "./api";
import { AthleteDetailScreen } from "./AthleteDetailScreen";
import { useThemePalette } from "./theme";

// Thin web-rnw mount of the shared <CoachDashboard> (CO-8) — the same pattern as
// InboxScreen: resolve the host theme, run the data hook, hand the model to the
// shared presentational tree, which owns its own loading/error gate. The CO-9
// drill-down is a local master/detail toggle (selected card state), NOT a shell
// surface: the detail is a child of the dashboard, not a peer nav tab.
export function CoachDashboardScreen({
  athleteSubs,
}: {
  // null until the caller's edges resolve — see useCoachDashboard.
  athleteSubs: ReadonlyArray<string> | null;
}) {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const { loading, error, data } = useCoachDashboard(apiFetch, athleteSubs);
  const [selected, setSelected] = useState<CoachAthleteCard | null>(null);

  if (selected) {
    // «Edit targets» authority is the SERVER's (PATCH /targets → 403
    // no_write_grant); the detail shows it and the editor handles the 403.
    return (
      <AthleteDetailScreen card={selected} onBack={() => setSelected(null)} />
    );
  }

  return (
    <ScrollView contentContainerStyle={styles.content}>
      <CoachDashboard
        theme={theme}
        data={data}
        loading={loading}
        error={error}
        onSelectAthlete={setSelected}
      />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  content: { paddingBottom: 48, flexGrow: 1 },
});
